<div *ngIf="!displayMobileView" class="content-table-pointer">
  <ion-row class="content" routerLink="/app/report/edit-report/{{ row.id }}">
    <ion-col size="4">
      {{ row.number }}
    </ion-col>
    <ion-col size="4">
      {{ row.createdBy?.firstName }} {{ row.createdBy?.lastName }}
    </ion-col>
    <ion-col size="4">
      {{ row.createdAt | dateSti }}
    </ion-col>
    <ion-col size="3">
      {{ row.building.name }}
    </ion-col>
    <ion-col [attr.size]="customData != 'hidePriority' ? '3' : '4'">
      {{ row.title }}
    </ion-col>
    <ion-col size="3" *ngIf="customData != 'hidePriority'">
      <div>
        <app-status
          [color]="
            dictionaryServ.getDictionaryValueColor(
              dictionaryServ.reportPriorityValues,
              row.priority
            )
          "
          [name]="
            dictionaryServ.valueName(
              dictionaryServ.reportPriorityValues,
              row.priority
            )
          "
        ></app-status>
      </div>
    </ion-col>
    <ion-col [attr.size]="customData != 'hidePriority' ? '3' : '5'">
      <div>
        <app-status
          [color]="
            dictionaryServ.getDictionaryValueColor(
              dictionaryServ.reportStatusValues,
              row.status
            )
          "
          [name]="
            dictionaryServ.valueName(
              dictionaryServ.reportStatusValues,
              row.status
            )
          "
        ></app-status>
      </div>
    </ion-col>
  </ion-row>
</div>

<ion-card
  *ngIf="displayMobileView"
  class="content-card-noborder"
  routerLink="/app/report/edit-report/{{ row.id }}"
>
  <ion-card-content class="invitation-mobile-header">
    <ion-grid class="no-padding-grid">
      <ion-row>
        <ion-col class="space-between">
          <app-status
            [color]="
              dictionaryServ.getDictionaryValueColor(
                dictionaryServ.reportStatusValues,
                row.status
              )
            "
            [name]="
              dictionaryServ.valueName(
                dictionaryServ.reportStatusValues,
                row.status
              )
            "
          ></app-status>
          <ion-text class="report-number">{{ row.number }}</ion-text>
        </ion-col>
      </ion-row>
    </ion-grid>
    <div class="line-divider"></div>
  </ion-card-content>

  <ion-card-header class="header">
    <ion-card-title class="title">
      <span>
        {{ row.title }}
        <span class="priority-flag">
          <ion-icon src="../../../../assets/icons/flag.svg"> </ion-icon>
        </span>
      </span>
    </ion-card-title>
  </ion-card-header>

  <ion-card-content>
    <ion-grid class="no-padding-grid content-grid">
      <ion-row>
        <ion-col>
          <ion-icon
            mobile
            src="assets/icons/calendar-gray.svg"
            size="large"
          ></ion-icon>
          <ion-text class="icon-label-text">{{
            row.createdAt | dateSti
          }}</ion-text>
        </ion-col>
      </ion-row>
      
      <ion-row>
        <ion-col>
          <ion-icon
            mobile
            src="assets/icons/building.svg"
            size="large"
          ></ion-icon>
          <ion-text class="icon-label-text">{{ row.building.name }}</ion-text>
        </ion-col>
      </ion-row>

      <ion-row>
        <ion-col>
          <app-user-with-avatar
            [showUserText]="true"
            [user]="row.createdBy"
          ></app-user-with-avatar>
        </ion-col>
      </ion-row>
    </ion-grid>
  </ion-card-content>
</ion-card>
